import React, { useState } from 'react'
import { graphql } from 'gatsby'
import { Fade } from 'react-reveal'
import { Parallax } from 'react-scroll-parallax'
import parse from 'html-react-parser'

import * as styles from './tabsWithRichText.module.scss'

const TabsWithRichText = ({ component: { id, image, tabGroups, heading } }) => {
  const [active, setActive] = useState(0)
  return (
    <section id={id} className={styles.section}>
    <Fade left>
      <div className={styles.headingContainer}>
        <h2 className={styles.heading}>{heading}</h2>
      </div>
      </Fade>
      <Fade left cascade>
        <div className={styles.links}>
          {tabGroups.map((tab, i) => {
            const handleChangeActive = () => {
              setActive(i)
            }
            return (
              <button key={i} className={styles.programLink + `${active === i ? ` ${styles.active}` : ''}`} onClick={handleChangeActive}>
                <p className={styles.iconLabel}>{tab.label}</p>
              </button>
            )
          })}
        </div>
      </Fade>

      <Fade right delay={500}>
        <div className={styles.image + ' background-cover-center'} style={{ backgroundImage: `url(${image})` }} />
      </Fade>
      <Fade left delay={1000}>
        <div className={styles.arrowContainer}>
          <Parallax x={[-100, 100]}>
            <div className={styles.arrow + ' background-contain-center'} />
          </Parallax>
        </div>
      </Fade>
      {tabGroups && tabGroups[active] &&
        <div className={styles.program}>
          <Fade down>
            <div className={styles.fadeTop} />
            <div className={styles.fadeBottom} />
            <div className={styles.textContainer}>
              {tabGroups[active].content ? parse(tabGroups[active].content) : null}
            </div>
          </Fade>
        </div>}
    </section>
  )
}

export default TabsWithRichText

export const query = graphql`
  fragment TabsWithRichText on PagesJson {
    components {
      image
      heading
      tabGroups {
        label
        content
      }
    }
  }
`
